import request from '../libs/request';
import lodop from '../libs/lodop';
import dateFormat from 'date-fns/format';
import saveAs from 'file-saver';

const res = 'CustomModel';

export default {
  add(modelName, model) {
    return request({
      url: `api/${res}/add`,
      method: 'post',
      data: {
        modelName,
        model
      }
    });
  },
  update(modelName, model) {
    return request({
      url: `api/${res}/update`,
      method: 'put',
      data: {
        modelName,
        model
      }
    });
  },
  remove(modelName, id) {
    return request({
      url: `api/${res}/remove`,
      method: 'delete',
      data: {
        modelName,
        id
      }
    });
  },
  batchSave(modelName, data) {
    return request({
      url: `api/${res}/batchSave`,
      method: 'post',
      data: {
        modelName,
        data
      }
    });
  },
  get(modelName, id) {
    return request({
      url: `api/${res}/get`,
      method: 'get',
      params: {
        modelName,
        id
      }
    });
  },
  query(modelName, filter) {
    let path = filter.isGroupBy ? 'group' : 'query';
    return request({
      url: `api/${res}/${path}`,
      method: 'post',
      data: {
        ...filter,
        modelName
      }
    });
  },
  async exportExcel(tableView, filter) {
    let data = {
      ...filter,
      modelName: tableView.model,
      per: 100000,
      returnType: 1,
      viewCode: tableView.code
    };

    let result;

    if (tableView.isGroupBy) {
      data.groupColumn = JSON.parse(tableView.groupColumn);
      data.groupMethod = JSON.parse(tableView.groupMethod);

      await request({
        url: `api/${res}/group`,
        method: 'post',
        responseType: 'blob',
        data
      });
    } else {
      await request({
        url: `api/${res}/query`,
        method: 'post',
        responseType: 'blob',
        data
      });
    }

    const blob = new Blob([result], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, tableView.name + '-' + dateFormat(new Date(), 'yyyyMMddHHmmss') + '.xlsx');
  },
  async exportPdf(tableView, filter) {
    let data = {
      ...filter,
      modelName: tableView.model,
      per: 100000,
      returnType: 3,
      viewCode: tableView.code
    };

    let result;

    if (tableView.isGroupBy) {
      data.groupColumn = JSON.parse(tableView.groupColumn);
      data.groupMethod = JSON.parse(tableView.groupMethod);

      await request({
        url: `api/${res}/group`,
        method: 'post',
        responseType: 'blob',
        data
      });
    } else {
      await request({
        url: `api/${res}/query`,
        method: 'post',
        responseType: 'blob',
        data
      });
    }

    const blob = new Blob([result], { type: 'application/pdf' });
    saveAs(blob, tableView.name + '-' + dateFormat(new Date(), 'yyyyMMddHHmmss') + '.pdf');
  },
  async printList(tableView, filter, landscape = true) {
    let LODOP;
    try {
      LODOP = lodop.getLodop();
    } catch (e) {
      alert(window.$t('Front_Msg_Check_Print_Driver') + e.message);
      return;
    }

    let data = {
      ...filter,
      modelName: tableView.model,
      per: 1000,
      returnType: 2,
      viewCode: tableView.code
    };

    let result;

    if (tableView.isGroupBy) {
      data.groupColumn = JSON.parse(tableView.groupColumn);
      data.groupMethod = JSON.parse(tableView.groupMethod);

      result = await request({
        url: `api/${res}/group`,
        method: 'post',
        responseType: 'blob',
        data
      });
    } else {
      result = await request({
        url: `api/${res}/query`,
        method: 'post',
        responseType: 'blob',
        data
      });
    }

    LODOP.PRINT_INIT('Print');

    if (landscape) {
      LODOP.ADD_PRINT_TABLE('4%', '3%', '94%', '90%', result);
      LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4');
    } else {
      LODOP.ADD_PRINT_TABLE('4%', '3%', '94%', '90%', result);
      LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4');
    }
    LODOP.PRINTA();
  }
};
